export const AccordionUnavailable = ({
  imgSrc,
  title,
  isBorderTop = true,
  accordionUnavailableClassName
}: {
  imgSrc: string
  title: string
  isBorderTop?: boolean
  accordionUnavailableClassName?: string
}) => {
  return (
    <div
      className={`flex gap-4 ${isBorderTop ? 'border-t border-[#EBF2F2]' : ''} ${accordionUnavailableClassName ?? ''}`}
    >
      <div>
        <img src={imgSrc} />
      </div>
      <div className='flex flex-col justify-between text-[#8E9393]'>
        <div className='font-[500] text-[14px]'>{title}</div>
        <div className='font-[400] text-[13px]'>Unavailable</div>
      </div>
    </div>
  )
}
